<!-- 图片上传占位效果：表单创建和预览共用 -->
<template>
  <div class="image-upload-place">
    <p class="upload-remark">
      {{ uploadTip }}
    </p>
    <div class="imitate-upload">
      <div style="text-align: center">
        <i class="iconfont-v3 saasline-plus"></i>
      </div>
    </div>
  </div>
</template>
<script>
  import presetConfig from './config';

  export default {
    data() {
      return {
        presetConfig: presetConfig
      };
    },
    computed: {
      uploadTip() {
        return this.languageType == 2
          ? this.presetConfig.en.uploadTip
          : this.presetConfig.zh.uploadTip;
      }
    },
    props: {
      // 1 中文，2：英文, 默认为 1
      languageType: {
        type: [Number, String],
        default: 1
      }
    }
  };
</script>

<style lang="less" scoped>
  .image-upload-place {
    .upload-remark {
      color: #262626;
      font-size: 14px;
      line-height: 2.4;
    }
    .imitate-upload {
      background: #f7f7f7;
      width: 160px;
      height: 90px;
      border-radius: 8px;
      border: 1px solid #cccccc;
      color: #999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      i {
        font-size: 26px;
      }

      .upload-tip {
        text-align: center;
        padding: 0 6px;
        line-height: 1.5;
        font-size: 12px;
      }
    }
  }
</style>
